import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { AppLoginModalComponent } from '../app-login/app-login.component'
import { CopyrightAlertComponent } from '../shared/copyright-alert/copyright-alert.component';

import { DbService } from '../../db.service';
import { SessionService } from '../../session.service';
import { SpinnerService } from '../../spinner.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CopyrightAlertService } from '../../services/copyright-alert.service';

import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';

declare var powerbi: any;

@Component({
    selector: 'app-solicitacoes-especiais',
    templateUrl: './solicitacoes-especiais.component.html',
    styleUrls: ['./solicitacoes-especiais.component.css']
})

export class SolicitacoesEspeciaisComponent implements AfterViewInit {
    @ViewChild("login") login: AppLoginModalComponent;
    @ViewChild('embeddedReport') embeddedReport: ElementRef;
    config: any;
    modalRef: BsModalRef;

    showBloqueio: boolean = false;
    showAssinaturaRequerida: boolean = false;
    descricao: string = '';
    private relatorioParaCarregar: any = null;

    constructor(
        private _scrollToService: ScrollToService,
        private dbService: DbService,
        private router: Router,
        private route: ActivatedRoute,
        private sessionService: SessionService,
        private spinnerService: SpinnerService,
        private modalService: BsModalService,
        private copyrightAlertService: CopyrightAlertService
    ) {
        const snapshotParams = this.route.snapshot.params;
        this.descricao = snapshotParams['dsRelatorio'] || '';
        
        if (snapshotParams['idRelatorioPB'] && snapshotParams['dsRelatorio']) {
            this.fnPesquisar();
        }
        
        this.route.params.subscribe(params => {
            if (params['dsRelatorio'] && params['dsRelatorio'] !== this.descricao) {
                this.descricao = params['dsRelatorio'] || '';
                this.fnPesquisar();
            }
        });
    }

    ngAfterViewInit() {
        if (this.relatorioParaCarregar) {
            setTimeout(() => {
                if (this.embeddedReport && this.embeddedReport.nativeElement) {
                    this.carregarRelatorio(this.relatorioParaCarregar);
                    this.relatorioParaCarregar = null;
                }
            }, 200);
        }
    }

    showCopyrightAlert(): void {
        this.copyrightAlertService.resetCopyrightAcceptance();
        
        this.modalRef = this.modalService.show(CopyrightAlertComponent, {
            class: 'modal-dialog-centered',
            backdrop: 'static',
            keyboard: false
        });

        this.copyrightAlertService.copyrightAccepted$.subscribe(accepted => {
            if (accepted) {
                this.loadPowerBIReport();
            }
        });
    }

    fnPesquisar() {
        const sessao = JSON.parse(sessionStorage.getItem('sessao_usuario')  || '{}');

        var idRelatorioPB = this.route.snapshot.params['idRelatorioPB'];
        var dsRelatorio = this.route.snapshot.params['dsRelatorio'];
        
        if (!this.descricao && dsRelatorio) {
            this.descricao = dsRelatorio;
        }

        if (!idRelatorioPB || idRelatorioPB === '00'){
            this.showBloqueio = true;
            this.showAssinaturaRequerida = false;
        } else {
            this.dbService.post('EmbedInfo/VerificaPermissaoSE', sessao.hash).subscribe(
                resultComum => {
                    if (!resultComum.permissao) 
                    {
                        this.fnScrollTo();
                        this.showBloqueio = true;
                        this.showAssinaturaRequerida = true;
                    } else {
                        this.showAssinaturaRequerida = false;
                        this.showBloqueio = false;
                        this.showCopyrightAlert();
                    }
                },
                error => {
                    this.showBloqueio = true;
                    this.showAssinaturaRequerida = true;
                }
            ); 
        }        
    }

    loadPowerBIReport(): void {
        const sessao = JSON.parse(sessionStorage.getItem('sessao_usuario') || '{}');
        var idRelatorioPB = this.route.snapshot.params['idRelatorioPB'];
        var url = 'EmbedInfo/GetSolicitacoesEspeciais?idRelatorio=' + idRelatorioPB;

        this.dbService.get(url).subscribe(
            result => {
                if (!result || !result.embedToken || !result.embedReport) {
                    this.showBloqueio = true;
                    this.showAssinaturaRequerida = true;
                    return;
                }
                
                const model = window['powerbi-client'].models;
                const basicFilter = {
                    $schema: "http://powerbi.com/product/schema#basic",
                    target: {
                        table: "VW_ASSINATURAS_ATIVAS_NC",
                        column: "IdCliente"
                    },
                    operator: "In",
                    values: [sessao.idUsuario],
                    filterType: model.FilterType.BasicFilter,
                }
                    
                this.config = result;
                                
                const embedConfig = {
                    type: 'report',
                    tokenType: model.TokenType.Embed,
                    accessToken: result.embedToken.token,
                    embedUrl: result.embedReport[0].embedUrl,
                    permissions: model.Permissions.All,
                    filters: [basicFilter],
                    settings: {
                        filterPaneEnabled: false,
                        navContentPaneEnabled: false,
                        layoutType: model.LayoutType.Custom,
                        customLayout: {
                            displayOption: model.DisplayOption.FitToWidth
                        }
                    }
                }
                                
                setTimeout(() => {
                    if (this.embeddedReport && this.embeddedReport.nativeElement) {
                        this.carregarRelatorio(embedConfig);
                    } else {
                        this.relatorioParaCarregar = embedConfig;
                    }
                }, 100);
            },
            error => {
                if (error.status === 401) {
                    this.fnScrollTo();
                    this.showBloqueio = true;
                    this.showAssinaturaRequerida = true;
                } else {
                    this.showBloqueio = true;
                    this.showAssinaturaRequerida = true;
                }
            }
        );
    }

    fullscreen() {
        var embedContainer = this.embeddedReport.nativeElement
        var report = powerbi.get(embedContainer);
        report.fullscreen();
    }

    carregarRelatorio(embedConfig: any) {
        try {
            if (!this.embeddedReport || !this.embeddedReport.nativeElement) {
                return;
            }
            
            var report = powerbi.embed(this.embeddedReport.nativeElement, embedConfig);
            report.fullscreen();
        } catch (error) {
            this.showBloqueio = true;
            this.showAssinaturaRequerida = true;
        }
    }

    fnScrollTo() {
        const config: ScrollToConfigOptions = {
            target: 'resultado',
            offset: -97
        };
      
        this._scrollToService.scrollTo(config);
    }

}
